import React, { Component } from "react";
import { Collapse, Spinner, Button, Icon, Popover, Menu, MenuItem } from "@blueprintjs/core";
import UISelect from "../../components-fm/UISelect";
import {  PLAYERS_TRAINING_STATUS } from '../../utils/constants'


export default class PlayersStatusRow extends Component {
    renderSection(label, key, list) {
        const { collapsed, onToggleColl } = this.props;
        return (
            <div className="sidebar-section">
                <div
                    className="section-header"
                    onClick={() => onToggleColl(key)}
                >
                    <span className="f-5">{label}: </span>
                    <span className="f-5">{list.length}</span>

                </div>

                <Collapse isOpen={!collapsed[key]}>
                    {list.map((p, idx) => (
                        <div key={p.id} className="l1-list-item">
                            <UISelect
                                items={
                                    PLAYERS_TRAINING_STATUS
                                }
                                // selectedItem={}
                                onItemSelect={(selectedStatus) => this.props.onChangeStatus(p.id, selectedStatus.key)}
                                placeholder="Status"
                                button={
                                    <>
                                        <span className="f-3">{idx + 1}.</span>
                                        <span className="f-4">{p.name}</span>
                                    </>
                                }
                            />

                            {
                                p.status === 'accidentat' && <Icon icon="plus" size={22} />
                            }
                        </div>
                    ))}
                </Collapse>
            </div>
        );
    }

    render() {
        const { players, loading, error, sidebarOpen, onToggleAll } = this.props;
        const active = players.filter(p => p.status === "active" || !p.status);
        const injured = players.filter(p => p.status === "accidentat");
        // const suspendat = players.filter(p => p.status === "suspendat");
        const absent = players.filter(p => p.status === "absent");
        const excused = players.filter(p => p.status === "invoit");
        const unselected = players.filter(p => p.status === "neconvocat");


        return (
            <div className="status-row">
                <div className="sidebar-content">
                    {loading && <Spinner size={20} />}
                    {error && <p className="bp5-text-danger">{error}</p>}

                    {!loading && !error && (
                        <>
                            {this.renderSection("Participă", "active", active)}
                            {this.renderSection("Acc", "injured", injured)}
                            {this.renderSection("Abs", "absent", absent)}
                            {this.renderSection("Învoiți", "excused", excused)}
                            {this.renderSection("N", "unselected", unselected)}
                        </>
                    )}
                </div>

                {/* buton toggle vizibil doar desktop (hidden sub 968) */}
                {/* <Button
                    icon={sidebarOpen ? "chevron-left" : "chevron-right"}
                    minimal
                    onClick={onToggleAll}
                    className="toggle-button desktop-only"
                /> */}
            </div>
        );
    }
}
